import { isSameId } from "../../helpers";
export default function (store, ev) {
    const state = store.getState();
    let originalColumn;
    const id = ev.id || ev.column?.id;
    const columns = state.columns.map(col => {
        if (isSameId(col.id, id)) {
            originalColumn = { ...col };
            if (ev.replace) {
                return { id, ...ev.column };
            }
            return { ...col, ...ev.column };
        }
        return col;
    });
    store.setState({ columns });
    return () => {
        store.in.exec("update-column", {
            column: originalColumn,
            replace: true,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=update.js.map